/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetDoctorsSuccessfulActionPayload,
  GetDoctorByIdActionPayload,
  GetDoctorByIdSuccessfulActionPayload,
  CreateDoctorActionPayload,
  CreateDoctorSuccessfulActionPayload,
  UpdateDoctorActionPayload,
  UpdateDoctorSuccessfulActionPayload,
  DeleteDoctorActionPayload,
  DeleteDoctorSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/doctor-data-store';

/* action types */
export enum ActionTypes {
  GetDoctors = '[DOCTOR] GetDoctors',
  GetDoctorsSuccessful = '[DOCTOR] GetDoctorsSuccessful',
  GetDoctorsFailure = '[DOCTOR] GetDoctorsFailure',
  GetDoctorById = '[DOCTOR] GetDoctorById',
  GetDoctorByIdSuccessful = '[DOCTOR] GetDoctorByIdSuccessful',
  GetDoctorByIdFailure = '[DOCTOR] GetDoctorByIdFailure',
  CreateDoctor = '[DOCTOR] CreateDoctor',
  CreateDoctorSuccessful = '[DOCTOR] CreateDoctorSuccessful',
  CreateDoctorFailure = '[DOCTOR] CreateDoctorFailure',
  UpdateDoctor = '[DOCTOR] UpdateDoctor',
  UpdateDoctorSuccessful = '[DOCTOR] UpdateDoctorSuccessful',
  UpdateDoctorFailure = '[DOCTOR] UpdateDoctorFailure',
  DeleteDoctor = '[DOCTOR] DeleteDoctor',
  DeleteDoctorSuccessful = '[DOCTOR] DeleteDoctorSuccessful',
  DeleteDoctorFailure = '[DOCTOR] DeleteDoctorFailure',
  ResetState = '[DOCTOR] ResetState',
}

/* actions */

/* This event gets the all Doctors. */
export const GetDoctors = createAction(ActionTypes.GetDoctors);

/* This event is fired after getting all the Doctors successfully. */
export const GetDoctorsSuccessful = createAction(
  ActionTypes.GetDoctorsSuccessful,
  props<{ payload: GetDoctorsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Doctors. */
export const GetDoctorsFailure = createAction(ActionTypes.GetDoctorsFailure);

/* This event gets the Doctor by Doctor id. */
export const GetDoctorById = createAction(
  ActionTypes.GetDoctorById,
  props<{ payload: GetDoctorByIdActionPayload }>(),
);

/* This event is fired after getting all the Doctor by Doctor id successfully. */
export const GetDoctorByIdSuccessful = createAction(
  ActionTypes.GetDoctorByIdSuccessful,
  props<{ payload: GetDoctorByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Doctor by Doctor id successfully. */
export const GetDoctorByIdFailure = createAction(
  ActionTypes.GetDoctorByIdFailure,
);

/* This event creates a Doctor. */
export const CreateDoctor = createAction(
  ActionTypes.CreateDoctor,
  props<{ payload: CreateDoctorActionPayload }>(),
);

/* This event is fired after creating a Doctor successfully. */
export const CreateDoctorSuccessful = createAction(
  ActionTypes.CreateDoctorSuccessful,
  props<{ payload: CreateDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Doctor successfully. */
export const CreateDoctorFailure = createAction(
  ActionTypes.CreateDoctorFailure,
);

/* This event updates a Doctor. */
export const UpdateDoctor = createAction(
  ActionTypes.UpdateDoctor,
  props<{ payload: UpdateDoctorActionPayload }>(),
);

/* This event is fired after updating a Doctor successfully. */
export const UpdateDoctorSuccessful = createAction(
  ActionTypes.UpdateDoctorSuccessful,
  props<{ payload: UpdateDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Doctor successfully. */
export const UpdateDoctorFailure = createAction(
  ActionTypes.UpdateDoctorFailure,
);

/* This event deletes a Doctor. */
export const DeleteDoctor = createAction(
  ActionTypes.DeleteDoctor,
  props<{ payload: DeleteDoctorActionPayload }>(),
);

/* This event is fired after deleting a Doctor successfully. */
export const DeleteDoctorSuccessful = createAction(
  ActionTypes.DeleteDoctorSuccessful,
  props<{ payload: DeleteDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Doctor successfully. */
export const DeleteDoctorFailure = createAction(
  ActionTypes.DeleteDoctorFailure,
);

/* This event resets the Doctor state. */
export const ResetState = createAction(ActionTypes.ResetState);
